module.exports = __webpack_public_path__ + "img/wenskaarten-kerstkaarten-kerst-papette-quotes-1.d57dd5b4.jpg";